import { CompanySettings } from "@domain/Settings";
import { BaseDataModel } from "@domain/CRM/BaseDataModel";

type portalConfigurationOption =
	| "Import: Agrian (Echelon)"
	| "Import: Agrian (Agellum)"
	| "Import: Proagrica"
	| "Import: CSV + SHP"
	| "Import: Manual Entry"
	| "Import: Agvance"
	| "Import: FieldAlytics"
	| "Submission: No Files Needed"
	| "Submission: Show Special Lab Instructions"
	| "Import: SHP";

export type AgrianType = "Echelon" | "Agellum";

export class Company extends BaseDataModel {
	name!: string;
	portalConfigurationOptions!: portalConfigurationOption[];
	portalSettings!: CompanySettings;
	softwaresActive!: string[];
	branchIds!: string[];
	dealIds!: string[];
	externalLocationId?: string[];
	isActive!: number;
	agrianType?: AgrianType;
	externalSampleReferenceIdColumn?: string;
	/**
	 * Airtable formula: "Current" | "Previous" | "New". Current/Previous both
	 * require completed work, so together they identify present + past customers.
	 */
	customerStatus?: "Current" | "Previous" | "New";
}
